import ListingRowPhotoCount from './ListingRowPhotoCount'
import ListingRowCategoryCount from './ListingRowCategoryCount'
import ListingAccuracyPageCommands from "./listingAccuracy/ListingAccuracyPageCommands";

export default (addComponents, asDirective) => {

  addComponents([
    ['ListingRowPhotoCount', ListingRowPhotoCount],
    ['ListingRowCategoryCount', ListingRowCategoryCount],
    ['ListingAccuracyPageCommands', ListingAccuracyPageCommands],
  ])

  asDirective('listingRowPhotoCount', ListingRowPhotoCount, ['listing', 'providers'])
  asDirective('listingRowCategoryCount', ListingRowCategoryCount, ['listing', 'providers'])

}


